<template>
    <div>
        <!-- On Mobile -->
        <div v-if="selectedDevice === type" class="hidden-sm hidden-md hidden-lg">
            <vrm-form
                class="vrm-form__inner-box"
                @submit="addInstallation(type === 'replace_existing')"
            >
                <h2 v-if="!isReplaceExisting" v-html="deviceData.altName || deviceData.name"></h2>
                <p
                    v-if="isReplaceExisting"
                    @click="openCCGXUploadModal($event)"
                    v-html="
                        $t(`${deviceData.code_instruction_replace}`, {
                            i18nFallback: 'Add a personal access token',
                        })
                    "
                ></p>
                <p
                    v-else
                    @click="openCCGXUploadModal($event)"
                    v-html="
                        $t(`${deviceData.code_instruction}`, {
                            i18nFallback: 'Add a personal access token',
                        })
                    "
                ></p>

                <div
                    v-if="isReplaceExisting"
                    class="vrm-form__inner-box__alert"
                    v-html="
                        $t(`${deviceData.instruction_replace}`, {
                            i18nFallback: 'Instruction ',
                        })
                    "
                ></div>

                <fieldset class="vrm-fieldset">
                    <div class="vrm-fieldset__item">
                        <label
                            class="vrm-fieldset__item__label sg-textfield-label"
                            v-html="
                                isReplaceExisting
                                    ? $t(`addinstallation.addInstallationId_replace`, {
                                          i18nFallback: 'VRM Portal ID of replacement device',
                                      })
                                    : $t(`addinstallation.addInstallationId`, {
                                          i18nFallback: 'Add Installation ID',
                                      })
                            "
                        ></label>
                        <vrm-text-field
                            :id="'installationId_m_' + type"
                            ref="customValidations"
                            v-model="model.installation_identifier"
                            name="installationId"
                            :checks="[getCorrectValidation]"
                            :required="true"
                            class="sg-element"
                            type="text"
                            :placeholder="
                                $t(`${deviceData.placeholder}`, {
                                    i18nFallback: 'Vrm Portal ID',
                                })
                            "
                        ></vrm-text-field>
                    </div>
                    <div class="vrm-fieldset__item">
                        <label
                            class="vrm-fieldset__item__label sg-textfield-label"
                            v-html="
                                isReplaceExisting
                                    ? $t(`addinstallation.addInstallationName_replace`, {
                                          i18nFallback: 'The replacement device will be named as:',
                                      })
                                    : $t(`addinstallation.addInstallationName`, {
                                          i18nFallback: 'Add Installation Name',
                                      })
                            "
                        ></label>

                        <vrm-text-field
                            v-if="isReplaceExisting"
                            v-model="model.description"
                            class="sg-element"
                            type="text"
                            :placeholder="
                                $t(`general.replacement_installation`, {
                                    i18nFallback: 'Replacement GX Device',
                                })
                            "
                        ></vrm-text-field>

                        <vrm-text-field
                            v-else
                            v-model="model.description"
                            class="sg-element"
                            type="text"
                            :placeholder="
                                $t(`addinstallation.installation_name`, {
                                    i18nFallback: 'Installation Name',
                                })
                            "
                        ></vrm-text-field>
                    </div>
                </fieldset>
                <div
                    v-if="!isReplaceExisting"
                    class="vrm-form__inner-box__alert"
                    v-html="
                        $t(`${deviceData.instruction}`, {
                            i18nFallback: 'Instruction ',
                        })
                    "
                ></div>

                <div v-if="requiresWifiMac">
                    <div
                        v-if="deviceData.instruction_wifi_mac"
                        class="vrm-form__inner-box__alert"
                        v-html="
                            $t(`${deviceData.instruction_wifi_mac}`, {
                                i18nFallback: wifi_mac_fallback,
                            })
                        "
                    ></div>
                    <fieldset class="vrm-fieldset">
                        <div class="vrm-fieldset__item">
                            <label
                                class="vrm-fieldset__item__label sg-textfield-label"
                                v-html="
                                    $t(`addinstallation.addInstallationWifiMac`, {
                                        i18nFallback: 'WiFi MAC',
                                    })
                                "
                            ></label>
                            <vrm-text-field
                                :id="'installationWifiMac_d_' + type"
                                ref="wifiMacValidations"
                                v-model="model.wifi_mac"
                                :required="true"
                                name="wifiMac"
                                class="sg-element"
                                :placeholder="
                                    $t(`${deviceData.placeholder_wifi_mac}`, {
                                        i18nFallback: 'wifi mac',
                                    })
                                "
                                type="text"
                            />
                        </div>
                    </fieldset>
                </div>

                <button
                    v-if="isReplaceExisting"
                    class="sg-btn sg-blue sg-element"
                    v-html="
                        $t(`addinstallation.add_gx`, {
                            i18nFallback: 'Add GX',
                        })
                    "
                ></button>

                <button
                    v-else
                    class="sg-btn sg-blue sg-element"
                    v-html="
                        $t(`addinstallation.addInstallation`, {
                            i18nFallback: 'Add installation',
                        })
                    "
                ></button>
            </vrm-form>
        </div>
        <!-- On Desktop -->
        <div v-for="(deviceData2, type2, index) in devicesOnRow" :key="index">
            <div v-if="selectedDevice === type2" class="col-sm-12 hidden-xs">
                <vrm-form
                    class="vrm-form__inner-box"
                    @submit="addInstallation(type2 === 'replace_existing')"
                >
                    <h2
                        v-if="!isReplaceExisting"
                        v-html="deviceData2.altName || deviceData2.name"
                    ></h2>
                    <p
                        v-if="isReplaceExisting"
                        @click="openCCGXUploadModal($event)"
                        v-html="
                            $t(`${deviceData2.code_instruction_replace}`, {
                                i18nFallback: 'Add a personal access token',
                            })
                        "
                    ></p>
                    <p
                        v-else
                        @click="openCCGXUploadModal($event)"
                        v-html="
                            $t(`${deviceData2.code_instruction}`, {
                                i18nFallback: 'Add a personal access token',
                            })
                        "
                    ></p>

                    <div
                        v-if="isReplaceExisting"
                        class="vrm-form__inner-box__alert"
                        v-html="
                            $t(`${deviceData2.instruction_replace}`, {
                                i18nFallback: 'Instruction ',
                            })
                        "
                    ></div>

                    <fieldset class="vrm-fieldset">
                        <div class="vrm-fieldset__item">
                            <label
                                class="vrm-fieldset__item__label sg-textfield-label"
                                v-html="
                                    isReplaceExisting
                                        ? $t(`addinstallation.addInstallationId_replace`, {
                                              i18nFallback: 'VRM Portal ID of replacement device',
                                          })
                                        : $t(`addinstallation.addInstallationId`, {
                                              i18nFallback: 'Add Installation ID',
                                          })
                                "
                            ></label>

                            <vrm-text-field
                                :id="'installationId_m_' + type2"
                                ref="customValidations"
                                v-model="model.installation_identifier"
                                name="installationId"
                                :checks="[getCorrectValidation]"
                                :required="true"
                                class="sg-element"
                                type="text"
                                :placeholder="
                                    $t(`${deviceData2.placeholder}`, {
                                        i18nFallback: 'Add a personal access token',
                                    })
                                "
                            ></vrm-text-field>
                        </div>
                        <div class="vrm-fieldset__item">
                            <label
                                class="vrm-fieldset__item__label sg-textfield-label"
                                v-html="
                                    isReplaceExisting
                                        ? $t(`addinstallation.addInstallationName_replace`, {
                                              i18nFallback:
                                                  'The replacement device will be named as:',
                                          })
                                        : $t(`addinstallation.addInstallationName`, {
                                              i18nFallback: 'Add Installation Name',
                                          })
                                "
                            ></label>

                            <vrm-text-field
                                v-if="type2 === 'replace_existing'"
                                v-model="model.description"
                                class="sg-element"
                                type="text"
                                :placeholder="'Replacement GX device'"
                            ></vrm-text-field>

                            <vrm-text-field
                                v-else
                                v-model="model.description"
                                class="sg-element"
                                type="text"
                                :placeholder="'Installation Name (Optional)'"
                            ></vrm-text-field>
                        </div>
                    </fieldset>
                    <div
                        v-if="!isReplaceExisting"
                        class="vrm-form__inner-box__alert"
                        v-html="
                            $t(`${deviceData2.instruction}`, {
                                i18nFallback: 'Instruction ',
                            })
                        "
                    ></div>

                    <div v-if="requiresWifiMac">
                        <div
                            v-if="deviceData2.instruction_wifi_mac"
                            class="vrm-form__inner-box__alert"
                            v-html="
                                $t(`${deviceData2.instruction_wifi_mac}`, {
                                    i18nFallback: wifi_mac_fallback,
                                })
                            "
                        ></div>
                        <fieldset class="vrm-fieldset">
                            <div class="vrm-fieldset__item">
                                <label
                                    class="vrm-fieldset__item__label sg-textfield-label"
                                    v-html="
                                        $t(`addinstallation.addInstallationWifiMac`, {
                                            i18nFallback: 'WiFi MAC',
                                        })
                                    "
                                ></label>

                                <vrm-text-field
                                    :id="'installationWifiMac_d_' + type2"
                                    ref="wifiMacValidations"
                                    v-model="model.wifi_mac"
                                    :checks="[getCorrectValidation]"
                                    :required="true"
                                    name="wifiMac"
                                    class="sg-element"
                                    :placeholder="
                                        $t(`${deviceData2.placeholder_wifi_mac}`, {
                                            i18nFallback: 'wifi mac',
                                        })
                                    "
                                    type="text"
                                />
                            </div>
                        </fieldset>
                    </div>

                    <button
                        v-if="isReplaceExisting"
                        class="sg-btn sg-blue sg-element"
                        v-html="
                            $t(`addinstallation.add_gx`, {
                                i18nFallback: 'Add GX Device',
                            })
                        "
                    ></button>

                    <button
                        v-else
                        class="sg-btn sg-blue sg-element"
                        v-html="
                            $t(`addinstallation.addInstallation`, {
                                i18nFallback: 'Add installation',
                            })
                        "
                    ></button>
                </vrm-form>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import VrmTextField from '@/vue/components/forms/VrmTextField.vue';
import VrmForm from '@/vue/components/forms/VrmForm';
import ConfirmSwapDevices from '@/vue/components/modals/ConfirmSwapDevicesModal';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

import { VALID_VRM_PORTAL_ID_IMEI, VALID_VRM_PORTAL_ID } from '@/vue/constants/validation-checks';

@Component({
    components: { VrmTextField, ConfirmSwapDevices, VrmForm },
    data: function() {
        return {
            model: {
                installation_identifier: this.$route.params.installationIdentifier,
                description: null,
                wifi_mac: null,
            },
            requiresWifiMac: false,
            wifi_mac_fallback:
                "<p>The VRM Portal ID, for example be300d83fff4, can be found on the GX device under Menu › Settings › VRM online portal.</p><p>For more information see our <a href='https://www.victronenergy.com/media/pg/Cerbo_GX/en/vrm-portal.html#UUID-ae6d6e24-ba26-2c3a-3421-af556b022b75' target='_blank'>Troubleshooting to VRM connectivity GX</a>  or our <a href='https://www.victronenergy.com/live/vrm_portal:getting_started' target='_blank'>VRM Manual</a></p>",
        };
    },
    methods: {
        clearModel() {
            // set input fields to untouched
            this.model = {
                installation_identifier: null,
                description: null,
                wifi_mac: null,
            };
        },

        async addInstallation(replace_existing) {
            //required as within then 'this' is not available
            const self = this;

            // Todo: change to function parameters instead of accessing the service.model obj directly
            this.AddInstallationService.model.installation_identifier = this.model.installation_identifier;
            this.AddInstallationService.model.wifi_mac = this.model.wifi_mac;
            if (this.model.description) {
                this.AddInstallationService.model.description = this.model.description;
            }

            this.AddInstallationService.addInstallation().then(async function(data) {
                if (data.idSite && data.success) {
                    self.InstallationsService.reload();
                    // Reload installation list
                    if (self.generalContext()) {
                        await self.SwapInstallationService.setCurrentInstallation(data.idSite);
                        this.VrmModalService.closeActiveModal();
                        //set selected device to this installation in angular controller
                    } else if (self.addInstallationContext()) {
                        // set it within the service

                        if (!replace_existing) {
                            const routeParams = {
                                name: 'base.installation.dashboard',
                                params: {
                                    id: data.idSite,
                                },
                            };
                            self.$router.replace(routeParams);
                        } else {
                            await self.SwapInstallationService.initModel();
                            self.SwapInstallationService.clearSelected();
                            await self.SwapInstallationService.setSelectedInstallation(data.idSite);
                            const model = self.SwapInstallationService.swapInstallationsModel;
                            // then open the swap devices modal
                            self.VrmModalService.openVueModal(ConfirmSwapDevices, {
                                context: 'addInstallation',
                                swapInstallationsModel: model,
                                initialStep: 0,
                            });
                        }
                    }
                } else if (data.error_code === 'admin_mail_sent') {
                    self.$router.replace('base.installation-overview');
                } else if (data.error_code === 'venus_duplicate_identifier') {
                    self.requiresWifiMac = true;
                }
            });
        },
        openCCGXUploadModal(event) {
            if (event.target.tagName !== 'A') return;

            const AddInstallationService = this.AddInstallationService;

            this.VrmModalService.openUploadModal(this.$rootScope, 'ccgx', function(files) {
                AddInstallationService.uploadCCGXcallback(files);
            });
        },
        generalContext() {
            return this.context === 'general';
        },
        addInstallationContext() {
            return this.context === 'addInstallation';
        },
        getDevices(start, end) {
            return Object.keys(this.devices)
                .slice(start, end)
                .reduce((obj, t) => ((obj[t] = this.devices[t]), obj), {});
        },
    },
    computed: {
        devicesOnRow: function() {
            let types = Object.keys(this.devices);
            const index = types.indexOf(this.type);
            const replace_gx = Object.keys(this.devices).indexOf('replace_existing');
            const last = replace_gx === -1 ? types.length - 1 : types.length - 2;
            if (index === replace_gx) {
                return this.getDevices(index, index + 1);
            }
            if (index % 3 === 2) {
                return this.getDevices(index - 2, index + 1);
            }
            //Values left
            else if (index === last) {
                const rest = index % 3;
                return this.getDevices(index - rest, index + 1);
            }
            return {};
        },
        getCorrectValidation: function() {
            const device = this.selectedDevice;
            if (device === 'vgr_ver') {
                return VALID_VRM_PORTAL_ID_IMEI;
            }
            if (device === 'replace_existing' && this.requiresWifiMac) {
                return VALID_VRM_PORTAL_ID_IMEI;
            }
            return VALID_VRM_PORTAL_ID;
        },
        isReplaceExisting: function() {
            return this.type === 'replace_existing';
        },
    },
})
@AngularLocaleBundle('general')
@AngularLocaleBundle('addinstallation')
@AngularDirective('vrm-add-installation-drop')
export default class VrmAddInstallationDrop extends Vue {
    /** @type AddInstallationService */
    @ngInject()
    AddInstallationService;

    /** @type InstallationsService */
    @ngInject()
    SwapInstallationService;

    /** @type InstallationsService */
    @ngInject()
    InstallationsService;

    /** @type VrmModalService */
    @ngInject()
    VrmModalService;

    @ngInject()
    $rootScope;

    @Prop({ type: Object, default: null })
    devices;
    @Prop({ type: String, default: null })
    selectedDevice;
    @Prop({ type: Object, default: null })
    deviceData;
    @Prop({ type: String, default: null })
    type;
    @Prop({ type: String, default: 'addinstallation' })
    context;
}
</script>
